/**
 * Shared presentational primitives used across all three MARS Portfolio tabs:
 *   - Section title + page-description callout.
 *
 * The pill-button groups that used to live here were folded into the shared
 * `@/components/SegmentedControl` (`variant="group"` / `"group-secondary"`).
 */
import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  description: ReactNode;
}

/** `<h3>` + description callout repeated above every tab. */
export function SectionHeader({ title, description }: SectionHeaderProps): JSX.Element {
  return (
    <>
      <h3 className="font-[var(--font-heading)] text-xl font-semibold text-[color:var(--text-dark)] m-0 mb-2">
        {title}
      </h3>
      <div className="bg-[color:var(--light-bg)] border-l-4 border-[color:var(--accent)] rounded px-4 py-3 mb-4">
        <p className="text-sm leading-relaxed text-[color:var(--text-dark)] opacity-80 m-0">
          {description}
        </p>
      </div>
    </>
  );
}
